<template>
  <div class="containers-layout">
    <v-row id="containersRow">
      <v-col sm="4" id="itemCol" v-for="(item, index) in containerNFTs" :key="index" @click="clickContainerNFT(item.tokenId, item.image, item.name, item.desc)">
        <img :src="item.image" alt="Container NFT" />
        <p id="nameP">{{ item.name }}</p>
      </v-col>
    </v-row>

    <v-pagination id="itemPag" v-model="curPage" :length="pagLen" :total-visible="5" circle @input="onPagination()"></v-pagination>
  </div>
</template>

<script>
  import Web3 from 'web3';
  import BigNumber from 'bignumber.js';

  import { sendGetRequest } from '../../utils/axios';
  const containerNFTAbi = require("../../constants/abis/containerNFT.json");

  export default {
    name: 'Containers',
    emits: ['click-container'],
    props: {
    },
    components: {
    },
    data: () => ({
      curPage: 1,
      pagLen: 0,
      perPage: 9,

      containerNFTs: [],
      containerNFTInfo: {},
      // Contract variables. eros god
      web3: '',
      containerNFTContract: '',
      currentAccount: '',
      ownedContainerNFTCnt: 0,
      // WordPress bind data. eros god
      wpData: wpData,
    }),
    mounted() {
      this.initialize();
    },
    methods: {
      async initialize() {
        if (typeof window.ethereum === 'undefined') return;

        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        this.currentAccount = accounts[0];

        const web3js = window.web3;
        if (typeof web3js === 'undefined') return;

        this.web3 = new Web3(web3js.currentProvider);

        this.web3.eth.defaultAccount = this.currentAccount;

        this.containerNFTContract = this.web3.eth.contract(containerNFTAbi).at(wpData.CONTAINER_NFT_CONTRACT_ADDRESS);

        let _this = this; console.log('Current Account: ', wpData.CONTAINER_NFT_CONTRACT_ADDRESS);
        this.containerNFTContract.balanceOf.call(this.currentAccount, function(err, res) {
          if (err) { console.log(err.code); return; }

          _this.ownedContainerNFTCnt = new BigNumber(res).toNumber(); console.log('owned Container NFT Cnt: ', _this.ownedContainerNFTCnt);
          if (_this.ownedContainerNFTCnt > 0) {
            let forEnd = _this.perPage;
            if (forEnd > _this.ownedContainerNFTCnt) forEnd = _this.ownedContainerNFTCnt;

            for (let i=0; i<forEnd; i++) {
              _this.getContainerNFTInfos(i);
            }
          }

          _this.pagLen = (_this.ownedContainerNFTCnt % _this.perPage) > 0 ?  Math.floor(_this.ownedContainerNFTCnt / _this.perPage) + 1 : _this.ownedContainerNFTCnt / _this.perPage;
        });
      },
      getContainerNFTInfos(pIndex) {
        let _this = this;

        this.containerNFTContract.tokenOfOwnerByIndex.call(this.currentAccount, pIndex, function(err, res) {
          if (err) { console.log(err.code); return; }

          let tokenIndex = res;
          _this.containerNFTContract.tokenURI.call(tokenIndex, function(err, res) {
            if (err) { console.log(err.code); return; }

            let tokenURI = res;
            sendGetRequest(tokenURI).then((tokenInfo) => {
              _this.containerNFTs.push({tokenId: tokenIndex, name: tokenInfo.data.name, desc: tokenInfo.data.description, image: tokenInfo.data.image });
            });
          });
        });
      },
      clickContainerNFT(pTokenId, pNftImgUrl, pNftName, pNftDesc) {
        this.containerNFTInfo = {};
        
        this.containerNFTInfo.tokenId = pTokenId;
        this.containerNFTInfo.image = pNftImgUrl;
        this.containerNFTInfo.name = pNftName;
        this.containerNFTInfo.desc = pNftDesc;

        this.$emit('click-container', this.containerNFTInfo);
      },
      onPagination() {
        this.containerNFTs = [];
        this.containerNFTInfo = {};

        if (this.ownedContainerNFTCnt <= 0) return;

        let startIndex = (this.curPage - 1) * this.perPage;
        let endIndex = (startIndex + this.perPage) < this.ownedContainerNFTCnt ? startIndex + this.perPage : this.ownedContainerNFTCnt;

        let _this = this;

        for (let i=startIndex; i<endIndex; i++) {
          this.containerNFTContract.tokenOfOwnerByIndex.call(this.currentAccount, i, function(err, res) {
            if (err) { console.log(err.code); return; }

            let tokenId = res;

            _this.containerNFTContract.tokenURI.call(tokenId, function(err, res) {
              if (err) { console.log(err.code); return; }

              let tokenURI = res;

              sendGetRequest(tokenURI).then((tokenInfo) => {
                _this.containerNFTs.push({tokenId: tokenId, name: tokenInfo.data.name, desc: tokenInfo.data.description, image: tokenInfo.data.image });
              });
            });
          });
        }
      },
    },
    computed: {
    },
  };
</script>

<style scoped>
  #containersRow {
    margin-top: 20px;
  }
  #containersRow #itemCol img {
    width: 100%;
    box-shadow: 0px 0px 40px -1px rgb(0 0 0 / 43%);
    border-radius: 7px;
  }
  #containersRow #itemCol #nameP {
    text-align: center;
    color: #FFFFFF;
    font-weight: 600;
    font-family: Architects Daughter;
  }
</style>



// WEBPACK FOOTER //
// src/components/Container/Containers.vue